export function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";

  return (
    /Instagram|FBAN|FBAV|FB_IAB|TikTok|Twitter|X\.com|Snapchat|LinkedInApp|Line\//i.test(
      ua
    ) || /; wv\)/i.test(ua)
  );
}

export function shouldUseReducedMedia() {
  if (typeof window === "undefined") return false;

  return (
    isInAppBrowser() ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}
